import { isNil } from 'lodash';

import { MobizPermissionAssignment } from './mobiz-permission-assignment.do';
import { SecurityScope } from './security-scope';
import { SerializableObject } from './serializable-object';

export class MobizRole extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public module: string;
  public key: string;
  public scope: SecurityScope;
  public scopeId: string;
  public name: string;
  public assignedPermissions: MobizPermissionAssignment[];

  protected coercePropertyType(propertyName: string, propertyValue: any): any {
    let returnValue = null;
    if (isNil(propertyValue)) {
      return returnValue;
    }

    switch (propertyName) {
      case 'assignedPermissions':
        let assignedPermissions: MobizPermissionAssignment[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(memberData => {
            let permission = new MobizPermissionAssignment(memberData);
            assignedPermissions.push(permission);
          });
        }
        return assignedPermissions;

      case 'modifiedUtc':
      case 'createdUtc':
        if (typeof propertyValue === 'string') {
          return new Date(propertyValue);
        }
        return propertyValue;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

  public isReadOnly(): boolean {
    return this.scope === SecurityScope.BuiltIn;
  }

}
